"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserialize = exports.hydrate = void 0;
require("reflect-metadata");
var hydrate = function (t, key) {
    if (key === void 0) { key = null; }
    if (!key) {
        return function (target, key) {
            var type = Reflect.getMetadata("design:type", target, key); // eslint-disable-line
            if (!target.METADATA) {
                target.METADATA = {};
            }
            target.METADATA[key] = t;
        };
    }
};
exports.hydrate = hydrate;
var getTypeClass = function (class_, key) {
    var type = Reflect.getMetadata("design:type", class_, key);
    if (type && type.name === "Array") {
        return class_.METADATA[key];
    }
    return type;
};
var deserializeArray = function (class_, data) {
    return data.reduce(function (previous, current) {
        previous.push(deserialize(class_, current)); // eslint-disable-line
        return previous;
    }, []);
};
var deserializeObject = function (class_, data) {
    if (data === null || data === undefined) {
        return null;
    }
    var _class = new class_();
    Object.keys(data).forEach(function (obj) {
        var typeClass = getTypeClass(_class, obj);
        var value = data[obj];
        if (typeClass) {
            if (Array.isArray(value)) {
                value = deserializeArray(typeClass, value);
            }
            else if (typeClass === Date) {
                value = new Date(value);
            }
            else {
                value = deserializeObject(typeClass, value);
            }
        }
        _class[obj] = value;
    });
    return _class;
};
var deserialize = function (class_, data) {
    if (Array.isArray(data)) {
        return deserializeArray(class_, data);
    }
    else {
        return deserializeObject(class_, data);
    }
};
exports.deserialize = deserialize;
//# sourceMappingURL=serialize.js.map